// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ktLO","image":"Header_image__2CDrk","name":"Header_name__1Rf3e","info":"Header_info__3a8FI","infoRow":"Header_infoRow__3GUPc"};